var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { isEntityWithCoordinates, isEntityWithCountry, isEntityWithLocation } from "@shapeable/types";
import { filter } from "lodash";
// a utility to extract coordinates from an entity, given the various possible fields which could contain them
export var entityWithCoordinates = function (entity) {
  var _a, _b, _c, _d;
  if (isEntityWithCoordinates(entity) && entity.longitude && entity.latitude) {
    return entity;
  }
  if (isEntityWithLocation(entity) && ((_a = entity.location) === null || _a === void 0 ? void 0 : _a.longitude) && ((_b = entity.location) === null || _b === void 0 ? void 0 : _b.latitude)) {
    return __assign(__assign({}, entity), {
      longitude: entity.location.longitude,
      latitude: entity.location.latitude
    });
  }
  if (isEntityWithCountry(entity) && ((_c = entity.country) === null || _c === void 0 ? void 0 : _c.longitude) && ((_d = entity.country) === null || _d === void 0 ? void 0 : _d.latitude)) {
    return __assign(__assign({}, entity), {
      longitude: entity.country.longitude,
      latitude: entity.country.latitude
    });
  }
  // we'll actually return null if this doesn't have necessary info, so we can filter these out.
  return null;
};
export var entitiesWithCoordinates = function (entities) {
  return filter(entities.map(entityWithCoordinates));
};
export var entityHasValidCoordinates = function (entity) {
  return !!(entity.latitude && entity.longitude) && entity.latitude > -90 && entity.latitude < 90 && entity.longitude > -180 && entity.longitude < 180;
};
export var entitiesWithValidCoordinates = function (entities) {
  return filter(entitiesWithCoordinates(entities), entityHasValidCoordinates);
};